 import vfooter from './footer.vue'

 export default  vfooter


// WEBPACK FOOTER //
// ./src/components/footer/index.js